import React, { useState } from "react";
import {Alert} from 'react-bootstrap';

const AlertTooSmallScreen = () => {

    const [active, setActive] = useState(window.innerWidth <= 800);
    const handleDismiss = () => setActive(false);

    return (
        <div>
            {active && <Alert bsStyle="warning" onDismiss={handleDismiss}>
                <p style={{'margin': '0', 'color': '#ffffff', 'fontFamily': 'Roboto, sans-serif'}}>
                    OKNO TWOJEJ PRZEGLĄDARKI JEST ZBYT MAŁE, ABY POPRAWNIE WYŚWIETLIĆ STRONĘ.
                    JEŚLI MIMO TO CHCESZ KONTYNUOWAĆ ZAMKNIJ TEN KOMUNIKAT.
                </p>
            </Alert>
            }
        </div>
    );
};

export default AlertTooSmallScreen;


// WEBPACK FOOTER //
// ./src/AlertTooSmallScreen.js